(function ($) {

    'use strict';

    var Raffles = {
        $form: $('form#raffles'),
        $success: $('#raffles-success'),
        $number: $('#raffle-number'),
        $number_sm: $('#raffle-number-sm'),
        $msg: $('#raffles-msg'),
        $loading: $('#raffles-loading'),
        init: function ()
        {
            this.bind();
        },
        bind: function ()
        {
            var self = this;
            // form submit
            this.$form.on('submit', function (e) {
                e.preventDefault();
                self.$msg.hide();
                var data = $(this).serializeArray();
                // si ya fue validada la rifa, vamos por el full submit (fill de rifa)
                if ($(this).hasClass('validated')) {
                    if (self.validateFullForm()) {
                        return self.fillRaffle(data);
                    }
                    return false;
                }
                return self.validateRaffle();
            });
        },
        validateRaffle: function ()
        {
            var code = this.$form.find('input#code').val(),
                number = this.$form.find('input#number').val(),
                self = this;

            // primer filtro
            if (code.length !== 6 || number.length === 0) {
                this.showMsg("Código y/o número de rifa incorrecto.");
                return false;
            }

            // segundo filtro (xhr)
            this.showLoading();
            $.post('/validateRaffle', {code:code, number:number}, function (res) {
                self.hideLoading();
                if (res.status === 0) {
                    self.showFillForm();
                    return true;
                }
                self.showMsg(res.message)
                return false;
            }, 'json');
        },
        validateFullForm: function ()
        {
            var dni = this.$form.find('input#dni').val(),
                name = this.$form.find('input#name').val(),
                email = this.$form.find('input#email').val(),
                phone = this.$form.find('input#phone').val(),
                birthday = this.$form.find('select#birthday').val();

            if (dni.length === 0 || name.length === 0 || phone.length === 0 || birthday.length === 0 || email.length === 0) {
                this.showMsg("Datos incompletos. Por favor completá todos los campos!");
                return false;
            }

            return true;
        },
        showMsg: function (msg)
        {
            this.$msg.show();
            this.$msg.find('p').text(msg);

            var offset = this.$msg.offset().top + this.$msg.height() / 2 - window.innerHeight / 2;

            $('html, body').animate({
                scrollTop: offset
            }, 400);
        },
        fillRaffle: function (data)
        {
            var self = this;

            this.showLoading();

            $.post('/fillRaffle', data, function (res) {
                self.hideLoading();
                if (res.status === 0) {
                    self.showSuccess();
                    self.$number.text(self.$form.find('input#number').val())
                    self.$number_sm.text(self.$form.find('input#number').val())
                    return true;
                }
                self.showMsg(res.message)
                return false;
            }, 'json');
        },
        showFillForm: function ()
        {
            this.$form.addClass('validated');

            var offset = this.$form.find('#full-form').offset().top + this.$form.find('#full-form').height() / 2 - window.innerHeight / 2;

            $('html, body').animate({
                scrollTop: offset
            }, 400);

            this.$form.find('input#code, input#number').attr('readonly', true);
            this.$form.find('button[type="submit"] span').text('Completar');
        },
        showSuccess: function ()
        {
            this.$form.remove();
            this.$success.show();
        },
        showLoading: function ()
        {
            this.$form.find('button[type="submit"]')
                .attr('disabled', true)
                .addClass('disabled');
        },
        hideLoading: function ()
        {
            this.$form.find('button[type="submit"]')
                .attr('disabled', false)
                .removeClass('disabled');
        }
    };

    Raffles.init();

}(jQuery));